/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import { McpServer, McpServer$inboundSchema } from "./mcpserver.js";
import {
  RemoteMcpServer,
  RemoteMcpServer$inboundSchema,
} from "./remotemcpserver.js";

/**
 * The atomically created remote MCP source and its linked disabled MCP server.
 */
export type CreateServerAndMcpServerResult = {
  /**
   * An MCP server configuration: authentication, environment, and backend selection for an MCP server.
   */
  mcpServer: McpServer;
  /**
   * A remote MCP server configuration
   */
  remoteMcpServer: RemoteMcpServer;
};

/** @internal */
export const CreateServerAndMcpServerResult$inboundSchema: z.ZodMiniType<
  CreateServerAndMcpServerResult,
  unknown
> = z.pipe(
  z.object({
    mcp_server: McpServer$inboundSchema,
    remote_mcp_server: RemoteMcpServer$inboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      "mcp_server": "mcpServer",
      "remote_mcp_server": "remoteMcpServer",
    });
  }),
);

export function createServerAndMcpServerResultFromJSON(
  jsonString: string,
): SafeParseResult<CreateServerAndMcpServerResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => CreateServerAndMcpServerResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'CreateServerAndMcpServerResult' from JSON`,
  );
}
